export default __webpack_public_path__ + "static/media/openBook.e9783c02.svg";